import React, { useEffect } from 'react';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';
import { useTranslation } from 'Shared/utils/hooks/use-translation';
import './LoadingScreenErrorPage.scss';

function LoadingScreenErrorPage() {
  const { tr } = useTranslation();

  useEffect(() => {
    setTimeout(() => window.location.reload(), 1500);
  }, []);

  return (
    <div className="loading-screen-error-page d-flex flex-column">
      <div className="p-4">
        <CharmaLogo type="longLogo" width="180" />
      </div>
      <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100">
        <div className="loading-screen-error-page-content d-flex flex-column align-items-center text-center px-3">
          <h1 className="loading-screen-error-page-title p-2">{tr('perform.loading_screen.title')}</h1>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreenErrorPage;
